module.exports = __webpack_public_path__ + "img/client8.4b5d4a74.png";